export const UrlIcon = () => {
  return (
    <svg fill='none' height='16' viewBox='0 0 16 16' width='16' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M4.80272 9.46851L2.69716 7.36295C1.40804 6.07383 1.40804 3.98259 2.69716 2.69347C3.34172 2.04891 4.19397 1.72663 5.03906 1.72663C5.88415 1.72663 6.73641 2.04891 7.38097 2.69347L9.47937 4.79187M6.52155 11.1873L8.62711 13.2929C9.27167 13.9375 10.1239 14.2597 10.969 14.2597C11.8141 14.2597 12.6664 13.9375 13.3109 13.2929C14.6 12.0038 14.6 9.91254 13.3109 8.62342L11.1982 6.5107M5.98442 5.98072L10.0093 10.0056'
        stroke='currentColor'
        strokeLinecap='round'
        strokeLinejoin='round'
        strokeMiterlimit='10'
      />
    </svg>
  )
}
